//@ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { FormsetWrapper } from "../../../components/FormWrapper";
import { OverlayRouter } from "../../../components/OverlayRouter";
import { FFormContext } from "../../../primitives/forms/FormField";
import { IEducationData, IEducationWorkHistoryStore } from "../../../stores";
import {
  Certification,
  CertificationForm,
} from "../../../tutor-revamp/Certification";
import {
  Education,
  EducationForm,
} from "../../../tutor-revamp/EducationHistory";
import educationHistoryData from "../../../tutor-revamp/formData/educationHistory.json";
import workHistoryData from "../../../tutor-revamp/formData/workHistory.json";
import certificationData from "../../../tutor-revamp/formData/certification.json";
import {
  WorkHistory,
  WorkHistoryForm,
} from "../../../tutor-revamp/WorkHistory";
import { scrollToTop } from "../../../utils/functions";
// import { Formset } from "./components";
import { Box, Button, Divider, Stack } from "@chakra-ui/react";
import { Formset } from "../../../tutor-revamp/forms/FormSet";

export type CredentialsFormType = {
  store: IEducationWorkHistoryStore;
  educationData: IEducationData;
  spacing?: number;
  onSubmit: any;
  isDisabled?: boolean;
  loading: boolean;
  countries: any[];
  educationJsonData?: {
    formTitle: { header: string };
    buttonText: { addText: string; save: string };
  };
  workHistoryJsonData?: any;
  certificationJsonData?: any;
  updateStore?: boolean;
  inContainer?: boolean;
};

export const CredentialsForm: React.FC<CredentialsFormType> = observer(
  ({
    store,
    onSubmit,
    loading,
    educationData,
    countries,
    educationJsonData = educationHistoryData,
    workHistoryJsonData = workHistoryData,
    certificationJsonData = certificationData,
    inContainer,
  }) => {
    const [showFormError, setShowFormError] = React.useState(false);
    const [toggleError, setToggleError] = React.useState(false);

    useEffect(() => {
      console.log("STORE:", store.formValues);
    }, [store]);

    const render = (
      <OverlayRouter>
        <Stack spacing={{ base: 16, md: 20 }}>
          <FFormContext.Provider
            value={{ placeholders: educationHistoryData.placeholders }}
          >
            <Formset
              asModal={false}
              isLoading={loading}
              path="/education-detail"
              formsetValues={store.educations}
              Component={Education}
              onEdit={store.editEducation}
              onAdd={store.addEducation}
              addButtonText={educationJsonData.buttonText.addText}
              onSave={async (data: any) => {
                if (data.school && data.course) {
                  store.saveEducation(data);
                  if (onSubmit) {
                    return onSubmit(store.formValues, false);
                  }
                }
              }}
              validateForm={(values) => {
                const isValid = Boolean(
                  values.school &&
                    values.course &&
                    values.speciality &&
                    values.startYear &&
                    values.endYear &&
                    values.degree &&
                    values.grade
                );
                if (isValid) {
                  setShowFormError(false);
                  return isValid;
                } else {
                  setShowFormError(true);
                }
              }}
              ComponentForm={EducationForm}
              formHeaderText={educationJsonData.formTitle.header}
              additionalFormProps={{ countries, showFormError, educationData }}
              currentFormIndex={store.currentEducationIndex}
              formDefaultValue={{ country: "Nigeria" }}
              onRemove={store.removeEducation}
              saveButtontext={educationJsonData.buttonText.save}
              FormsetHeader={inContainer ? FormsetWrapper : undefined}
              headerProps={
                inContainer
                  ? {
                      hideStep: false,
                      header: educationJsonData.formTitle.name,
                      description: educationJsonData.formTitle.subHeader,
                      buttonText: educationJsonData.buttonText.saveAndContinue,
                      shouldDisplayButton: false,
                      errorMessage:
                        toggleError &&
                        !store.educationCompleted &&
                        "Please fill all required fields",
                    }
                  : undefined
              }
            />
          </FFormContext.Provider>
          <FFormContext.Provider
            value={{ placeholders: workHistoryData.placeholders }}
          >
            <Formset
              isLoading={loading}
              path="/work-history-detail"
              formsetValues={store.workHistories}
              Component={WorkHistory}
              formHeaderText={workHistoryJsonData.formTitle.header}
              onEdit={store.editWorkHistory}
              onAdd={store.addWorkHistory}
              addButtonText="Add new work history"
              onSave={async (data: any) => {
                if (data.company && data.role) {
                  store.saveWorkHistory(data);
                  if (onSubmit) {
                    return onSubmit(store.formValues, false);
                  }
                }
              }}
              validateForm={(values) => {
                let { company, role, startYear } = values;
                let isValid = Boolean(company && role && startYear);
                if (isValid) {
                  setShowFormError(false);
                  return isValid;
                } else {
                  setShowFormError(true);
                }
              }}
              ComponentForm={WorkHistoryForm}
              FormsetHeader={inContainer ? FormsetWrapper : undefined}
              headerProps={
                inContainer
                  ? {
                      hideStep: false,
                      header: workHistoryJsonData.formTitle.name,
                      description: workHistoryJsonData.formTitle.subHeader,
                      buttonText:
                        workHistoryJsonData.buttonText.saveAndContinue,
                      shouldDisplayButton: false,
                      errorMessage:
                        toggleError &&
                        !store.workCompleted &&
                        "Please fill all required fields",
                    }
                  : undefined
              }
              additionalFormProps={{ showFormError }}
              currentFormIndex={store.currentWorkHistoryIndex}
              formDefaultValue={{}}
              onRemove={store.removeWorkHistory}
              saveButtontext={workHistoryJsonData.buttonText.save}
            />
          </FFormContext.Provider>
          <FFormContext.Provider
            value={{ placeholders: certificationData.placeholders }}
          >
            <Formset
              path="/certification-detail"
              isLoading={loading}
              formsetValues={store.certifications}
              Component={Certification}
              onEdit={store.editCertification}
              onAdd={store.addCertification}
              addButtonText="Add new certification"
              onSave={async (data: any) => {
                if (data.institution && data.name) {
                  store.saveCertification(data);
                  if (store.educationCompleted && store.workCompleted) {
                    setToggleError(false);
                    await onSubmit(store.formValues, false);
                  } else {
                    setToggleError(true);
                  }
                  // if (onSubmit) {
                  //   return onSubmit(data);
                  // }
                }
              }}
              validateForm={(values) => {
                let { name, institution } = values;
                let isValid = Boolean(name && institution);
                if (isValid) {
                  setShowFormError(false);
                  return isValid;
                } else {
                  setShowFormError(true);
                }
              }}
              ComponentForm={CertificationForm}
              FormsetHeader={inContainer ? FormsetWrapper : undefined}
              headerProps={
                inContainer
                  ? {
                      hideStep: false,
                      header: certificationJsonData.formTitle.name,
                      description: certificationJsonData.formTitle.subHeader,
                      buttonText:
                        certificationJsonData.buttonText.saveAndContinue,
                      shouldDisplayButton: true,
                      renderButton: (
                        <Box width="full" mt="60px !important">
                          <Button
                            type="submit"
                            size="lg"
                            onClick={() => {
                              if (
                                store.educationCompleted &&
                                store.workCompleted
                              ) {
                                setToggleError(false);
                                onSubmit(store.formValues);
                              } else {
                                setToggleError(true);
                              }
                            }}
                            isFullWidth
                            colorScheme="blue"
                            isLoading={loading}
                            loadingText="Saving..."
                          >
                            Save and continue
                          </Button>
                        </Box>
                      ),
                    }
                  : undefined
              }
              formHeaderText={certificationJsonData.formTitle.header}
              additionalFormProps={{ showFormError }}
              currentFormIndex={store.currentWorkHistoryIndex}
              formDefaultValue={{}}
              onRemove={store.removeWorkHistory}
              saveButtontext={certificationJsonData.buttonText.save}
            />
          </FFormContext.Provider>
        </Stack>
      </OverlayRouter>
    );
    return render;
  }
);
